import { Box, Switch, Text } from "@chakra-ui/react";
import React, { useState } from "react";
import Footer from "../../SharePages/Footer/Footer";
import FooterLR from "../FooterLR/FooterLR";
import Navbar from "../Navbar/Navbar";
import { nanoid } from "nanoid";
const data = [
  {
    title: "➢	There will be a fee associated with airline refunds.",
  },
  {
    title: "➢	There will be an associated service fee",
  },
  {
    title:
      "➢	Travelers are recommended to confirm the travelchamp 72 hours before the scheduled departure date if they wish to cancel or reissue. In such a case, a no-show fee can be charged in accordance with the airline policy. ",
  },

  {
    title:
      "	➢	Refunds only apply to refundable travel services. For domestic flights and flights abroad, the refund amount may appear in your account 3 to 7 working days and 3-6 weeks after the date of application, respectively.",
  },
  {
    title:
      "➢	The business will give you your money back in the exact same form that you paid with. When requesting refunds for any transactions made via Mobile Financial Services, the customer must pay a service/cash-out fee.",
  },
  {
    title:
      "➢	The service fee for domestic flights is BDT 100 and BDT 300 for international flights.",
  },
  {
    title:
      "➢	Flights on the same calendar date will not be subject to the payment void policy.",
  },
  {
    title:
      "➢	On low-cost carrier flights such as those operated by Air Asia, Indigo, SpiceJet, Jazeera Airways, Fly Dubai, etc. payment void would not be applied.",
  },
];

const Hotel = [
  {
    title:
      "➢	The info you see on our website comes from our providers and clients. The hotel management has the right to alter the rate at any moment.Even though we make every effort to check the information, we cannot be held liable for any errors that may be provided by vendors or hotel employees.",
  },
  {
    title:
      "➢	Prior to making a reservation, it is the customer`&apos`s responsibility to check whether or not the hotel has a refund policy.",
  },
  {
    title:
      "➢	Within 7 working days, the customer will receive the refund according to the specific hotel and bank policy. ",
  },

  {
    title:
      "	➢	No hotel reservation allows for date changes. You must rebook with the new date and cancel the prior reservation.",
  },
  {
    title:
      "➢	The service provider charges a service fee, which is not refundable.",
  },
];

const Tours = [
  {
    title:
      "➢	Before making a reservation, please review the policy listed under each tour.",
  },
  {
    title:
      "➢	Within 7 working days, the customer will receive their reimbursement according to the hotel and bank policy.",
  },
  {
    title:
      "➢ The service provider charges a service fee, which is not refundable. ",
  },
];

const RefundAndCancellation = () => {
  window.scrollTo(0, 0);
  const [isChecked, setIsChecked] = useState(false);
  const handleChange = () => {
    setIsChecked(!isChecked);
  };
  return (
    <>
      <Navbar></Navbar>
      <div className="container my-5 pb-5">
        <div className="row text-justify">
          {/* <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2 align-items-center">
              <p className="fw-bold">English</p>
              <Switch
                size="md"
                className="py-0 mb-0"
                isChecked={isChecked}
                onChange={handleChange}
              />
              <p className="fw-bold">বাংলা</p>
            </div>
          </div> */}

          {!isChecked ? (
            <>
              <div className="col-lg-12 px-1">
                <Text
                  fontWeight={700}
                  fontSize="20px"
                  pb={"10px"}
                  className="p-2"
                >
                  Refund and Cancellation
                </Text>
              </div>
              <Box pb={"30px"}>
                <Box className="bg-light my-1">
                  <Text className="p-1 fw-bold">Refund Policy</Text>
                </Box>
                <div className="p-1 pt-3">
                  <p>
                    - Travelchamp maintains the airlines' reissue and
                    cancellation policy.
                  </p>
                  <p>- There will be a fee associated with airline refunds. </p>
                  <p>- There will be an associated service fee. </p>
                  <p>
                    - Travelers are recommended to confirm Travelchamp 72 hours
                    before the scheduled departure date if they wish to cancel
                    or reissue.{" "}
                  </p>
                  <p>
                    - Refunds only apply to refundable travel services. For
                    domestic flights and flights abroad, the refund amount may
                    appear in your account 3 to 7 working days and 3-6 weeks
                    after the date of application, respectively.{" "}
                  </p>
                  <p>
                    -The business will give you your money back in the exact
                    same form that you paid with. When requesting refunds for
                    any transactions made via Mobile Financial Services, the
                    customer must pay a service/cash-out fee.{" "}
                  </p>
                  <p>
                    - Flights on the same calendar date will not be subject to
                    the payment void policy.{" "}
                  </p>
                </div>

                <Box className="bg-light mt-3">
                  <Text className="p-1 fw-bold">
                    Cancellation & Void Policy
                  </Text>
                </Box>

                <div className="p-1 pt-3">
                  <p>
                    - For cancellations and refunds, we always follow the
                    airline's refund policy. The airline solely holds the right
                    to change any policy. Travelchamp has no control over the
                    airline's policy.
                  </p>
                  <p>
                    - For any refund/cancellation/date change-related queries
                    kindly email us at refund@travelchamp.com. Or you can raise
                    your query directly on the support option on your portal.
                    Any service of the following will only be processed after
                    receiving approval from the client’s end.{" "}
                  </p>
                  <p>
                    - If airlines increase the fare of a ticket during the
                    booking period, the respective customer's must pay the
                    additional amount, else we will refund the paid amount. We
                    will be taking no charges for cancellation or void.{" "}
                  </p>
                  <p>
                    - In case of a date change/re-issue of the ticket for a
                    child who will be crossing the child age to adult (as per
                    airline policy) on the new travel date, a new charge of the
                    ticket will be the difference of airfare, plus a date change
                    fee of an adult along with any other charges applicable as
                    per airline policy.
                  </p>
                  <p>
                    - LCC carriers (Low Cost Carrier) such as Indigo & Air
                    Arabia flights are not subjected to void policy.
                  </p>
                  <p>
                    - International check-in counters close 1.5 hours before
                    flight time & domestic counters close 1 hour before the
                    flight time.
                  </p>
                </div>
              </Box>
            </>
          ) : (
            <>
              <div className="col-lg-12 px-1">
                <Text
                  fontWeight={700}
                  fontSize="20px"
                  pb={"10px"}
                  className="p-2"
                >
                  অর্থফেরত প্রদানের নীতি
                </Text>
              </div>
              <Box pb={"30px"}>
                <Box className="bg-light my-1">
                  <Text className="p-1 fw-bold">অর্থফেরত প্রদানের নীতি</Text>
                </Box>
                <div className="p-1 pt-3">
                  <p>
                    - ট্রাভেল চ্যাম্প লিমিটেড, এয়ারলাইন্স-এর রি-ইস্যু এবং
                    বাতিলকরণ নীতি অনুসরণ করে। সকল সেবা প্রদানকারী সংস্থা একটি
                    সেবা ফি চার্জ করে, যা ফেরতযোগ্য নয়। সেবা ফি হলো, গ্রাহককে
                    অনলাইন প্ল্যাটফর্ম থেকে প্রাপ্ত সহায়তা, সুবিধা এবং পরিসেবার
                    বিনিময়ে যা দিতে হবে। উল্লেখ্য বিষয়ঃ -
                  </p>
                  <p>- এয়ারলাইন্স এর রিফান্ডের একটি ফি যুক্ত থাকবে। </p>
                  <p>- একটি সংশ্লিষ্ট পরিসেবা ফি থাকবে। </p>
                  <p>
                    - ভ্রমণকারীরা যদি বাতিল বা রি-ইস্যু করতে চান তবে নির্ধারিত
                    তারিখের ৭২ ঘন্টা আগে ফার্স্টট্রিপ কে নিশ্চিত করার পরামর্শ
                    দেওয়া হয়। এই ক্ষেত্রে, এয়ারলাইন্সের নীতি অনুসারে একটি
                    নো-শো ফি নেওয়া হতে পারে।
                  </p>
                  <p>
                    - রিফান্ড শুধুমাত্র ফেরতযোগ্য ভ্রমণ পরিষেবাগুলিতে প্রযোজ্য।
                    অভ্যন্তরীণ ফ্লাইট এবং বিদেশে ফ্লাইটের জন্য রিফান্ডের পরিমাণ
                    আপনার অ্যাকাউন্টে ৫ থেকে ১০ কার্যদিবসের মধ্যে প্রদর্শিত হতে
                    পারে।
                  </p>
                  <p>
                    - প্রতিষ্ঠানটি আপনাকে আপনার অর্থ ঠিক একই মাধ্যমে ফেরত দেবে
                    যেভাবে আপনি দিয়েছিলেন। মোবাইল ফাইন্যান্সিয়াল সার্ভিসের
                    মাধ্যমে করা যেকোনো লেনদেনের জন্য রিফান্ডের অনুরোধ করার সময়
                    গ্রাহককে অবশ্যই একটি পরিষেবা/নগদ-আউট ফি দিতে হবে।
                  </p>
                  <p>
                    - একই ক্যালেন্ডার তারিখে ফ্লাইটগুলি পেমেন্ট বাতিল নীতির
                    আওতাভুক্ত হবে না ৷
                  </p>
                </div>

                <Box className="bg-light mt-3">
                  <Text className="p-1 fw-bold">
                    ক্যান্সেলেশন এবং ভয়েড নীতি
                  </Text>
                </Box>

                <div className="p-1 pt-3">
                  <p>
                    - ক্যান্সেলেশন ও রিফান্ডের ক্ষেত্রে নির্দিষ্ট এয়ারলাইনের
                    রিফান্ড পলিসির শর্তাবলি প্রযোজ্য হবে। এয়ারলাইন যেকোনো সময়
                    যে কোনো নীতি পরিবর্তন করার অধিকার রাখে এবং এয়ারলাইন কর্তৃক
                    প্রদত্ত নীতিমালার উপর ফার্স্টট্রিপের কোন নিয়ন্ত্রণ নেই।
                  </p>
                  <p>
                    - যেকোনো রিফান্ড/ ক্যান্সেলেশন /তারিখ পরিবর্তন-সম্পর্কিত
                    প্রশ্নের জন্য অনুগ্রহ করে refund@travelchamp.com-এ আমাদের
                    ইমেল করুন। অথবা পোর্টালের সাপোর্ট অপশনের মাধ্যমে সরাসরি সেবা
                    নিতে পারেন। শুধুমাত্র গ্রাহকদের কাছ থেকে অনুমোদন পাওয়ার পর
                    রিফান্ড/ ক্যান্সেলেশন /তারিখ পরিবর্তন করা হবে।
                  </p>
                  <p>
                    - বুকিংয়ের সময় কোনো টিকেটের ভাড়া বৃদ্ধি হলে গ্রাহকদের
                    সেই অতিরিক্ত পরিমাণ অর্থ প্রদানf করতে হবে, অন্যথায় পূর্বে
                    প্রদত্ত অর্থ ফেরত দিয়ে দেয়া হবে। ক্যান্সেলেশন বা ভয়েডের জন্য
                    ট্রাভেলচ্যাম্প লিমিটেড কোন চার্জ গ্রহণ করবে না।
                  </p>
                  <p>
                    - কোনো শিশুর টিকেটের তারিখ পরিবর্তন/রি-ইস্যু করার ক্ষেত্রে,
                    নতুন ভ্রমণের তারিখে শিশুটি প্রাপ্তবয়স্ক (এয়ারলাইন নীতি
                    অনুসারে) হলে টিকেট মুল্য পরিবর্তন, এয়ারলাইন নীতি অনুযায়ী
                    একজন প্রাপ্তবয়স্কের ক্ষেত্রে প্রযোজ্য ডেট চেঞ্জ ফি সহ
                    অন্যান্য চার্জ প্রযোজ্য হবে।
                  </p>
                  <p>
                    - লো কস্ট ক্যারিয়ার হিসেবে ইন্ডিগো এবং এয়ার অ্যারাবিয়ার
                    টিকেট ভয়েড পলিসির আওতাভুক্ত নয়।
                  </p>
                  <p>
                    - আন্তর্জাতিক চেক-ইন কাউন্টারগুলো ফ্লাইটের সময়ের ১.৫ ঘন্টা
                    আগে এবং দেশীয় কাউন্টারগুলো ফ্লাইটের সময়ের ১ ঘন্টা আগে বন্ধ
                    হয়ে যায়৷
                  </p>
                </div>
              </Box>
            </>
          )}
        </div>
      </div>
      <Footer></Footer>
    </>
  );
};

export default RefundAndCancellation;
